import { render, staticRenderFns } from "./customer-type-component.vue?vue&type=template&id=62e3c128&scoped=true"
import script from "./customer-type-component.vue?vue&type=script&lang=js"
export * from "./customer-type-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e3c128",
  null
  
)

export default component.exports